import featuresIcon1 from "../../assets/icons/brand.svg";
import featuresIcon2 from "../../assets/icons/detailed.svg";
import featuresIcon3 from "../../assets/icons/customizable.svg";

const featuresData = [
  {
    icon: featuresIcon1,
    heading: "Brand Recognition",
    info: "Boost your brand recognition with each click. Generic links don't mean a thing. Branded links help instill confidence in your content.",
  },
  {
    icon: featuresIcon2,
    heading: "Detailed Records",
    info: "Gain insights into who is clicking your links. Knowing when and where people engage with your content helps inform better decisions",
  },
  {
    icon: featuresIcon3,
    heading: "Fully Customizable",
    info: "Improve brand awareness and content discoverability through customizable links, supercharging audience engagement.",
  },
];

export default featuresData;
